import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AddCustomerMutationVariables = Types.Exact<{
  input: Types.AddCustomerInput;
}>;


export type AddCustomerMutation = { __typename?: 'Mutation', createCustomer: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, tenantId: string, customerId: string, name: string, description: string, currency: string, status: Types.CustomerStatus, sendOrderEmails: boolean, sendInvoiceEmails: boolean, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type EditCustomerMutationVariables = Types.Exact<{
  input: Types.EditCustomerInput;
}>;


export type EditCustomerMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, tenantId: string, customerId: string, name: string, description: string, currency: string, status: Types.CustomerStatus, sendOrderEmails: boolean, sendInvoiceEmails: boolean, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddLocationMutationVariables = Types.Exact<{
  input: Types.AddLocationInput;
}>;


export type AddLocationMutation = { __typename?: 'Mutation', addLocation: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveLocationMutationVariables = Types.Exact<{
  input: Types.RemoveLocationInput;
}>;


export type RemoveLocationMutation = { __typename?: 'Mutation', removeLocation: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateLocationMutationVariables = Types.Exact<{
  input: Types.UpdateLocationInput;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutation', updateLocation: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddContactMutationVariables = Types.Exact<{
  input: Types.AddContactInput;
}>;


export type AddContactMutation = { __typename?: 'Mutation', addContact: { __typename?: 'CustomerPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, description: string, currency: string, status: Types.CustomerStatus, sendOrderEmails: boolean, sendInvoiceEmails: boolean, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null } };

export type UpdateContactMutationVariables = Types.Exact<{
  input: Types.UpdateContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact: { __typename?: 'CustomerPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, description: string, currency: string, status: Types.CustomerStatus, sendOrderEmails: boolean, sendInvoiceEmails: boolean, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null } };

export type RemoveContactMutationVariables = Types.Exact<{
  input: Types.RemoveContactInput;
}>;


export type RemoveContactMutation = { __typename?: 'Mutation', removeContact: { __typename?: 'CustomerPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, description: string, currency: string, status: Types.CustomerStatus, sendOrderEmails: boolean, sendInvoiceEmails: boolean, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null } };

export type AddBillingAddressMutationVariables = Types.Exact<{
  input: Types.AddBillingAddressInput;
}>;


export type AddBillingAddressMutation = { __typename?: 'Mutation', addBillingAddress: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveBillingAddressMutationVariables = Types.Exact<{
  input: Types.RemoveBillingAddressInput;
}>;


export type RemoveBillingAddressMutation = { __typename?: 'Mutation', removeBillingAddress: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateBillingAddressMutationVariables = Types.Exact<{
  input: Types.UpdateBillingAddressInput;
}>;


export type UpdateBillingAddressMutation = { __typename?: 'Mutation', updateBillingAddress: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type InactivateCustomerMutationVariables = Types.Exact<{
  input: Types.InactivateCustomerInput;
}>;


export type InactivateCustomerMutation = { __typename?: 'Mutation', inactivateCustomer: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, orderEmailContactIds: Array<string>, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateCustomerMutationVariables = Types.Exact<{
  input: Types.ActivateCustomerInput;
}>;


export type ActivateCustomerMutation = { __typename?: 'Mutation', activateCustomer: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, orderEmailContactIds: Array<string>, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteCustomerMutationVariables = Types.Exact<{
  input: Types.DeleteCustomerInput;
}>;


export type DeleteCustomerMutation = { __typename?: 'Mutation', deleteCustomer: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, orderEmailContactIds: Array<string>, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type BatchInactivateCustomersMutationVariables = Types.Exact<{
  input: Types.BatchInactivateCustomersInput;
}>;


export type BatchInactivateCustomersMutation = { __typename?: 'Mutation', batchInactivateCustomers: { __typename?: 'CustomerBulkActionPayload', customers?: Array<{ __typename?: 'CustomerPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type BatchActivateCustomersMutationVariables = Types.Exact<{
  input: Types.BatchActivateCustomersInput;
}>;


export type BatchActivateCustomersMutation = { __typename?: 'Mutation', batchActivateCustomers: { __typename?: 'CustomerBulkActionPayload', customers?: Array<{ __typename?: 'CustomerPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type BatchDeleteCustomersMutationVariables = Types.Exact<{
  input: Types.BatchDeleteCustomersInput;
}>;


export type BatchDeleteCustomersMutation = { __typename?: 'Mutation', batchDeleteCustomers: { __typename?: 'CustomerBulkActionPayload', customers?: Array<{ __typename?: 'CustomerPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type MergeCustomerMutationVariables = Types.Exact<{
  input: Types.MergeCustomerInput;
}>;


export type MergeCustomerMutation = { __typename?: 'Mutation', mergeCustomer: { __typename?: 'CustomerPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, orderEmailContactIds: Array<string>, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null } };

export type UpdateCustomerOrderAddressEditPermissionsMutationVariables = Types.Exact<{
  input: Types.UpdateCustomerOrderAddressEditPermissionsInput;
}>;


export type UpdateCustomerOrderAddressEditPermissionsMutation = { __typename?: 'Mutation', updateCustomerOrderAddressEditPermissions: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', customerId: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateCustomerLocationOrderAddressEditPermissionsMutationVariables = Types.Exact<{
  input: Types.UpdateCustomerLocationOrderAddressEditPermissionsInput;
}>;


export type UpdateCustomerLocationOrderAddressEditPermissionsMutation = { __typename?: 'Mutation', updateCustomerLocationOrderAddressEditPermissions: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', customerId: string, locations: Array<{ __typename?: 'LocationData', id: string, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateCustomerSendOrderEmailsMutationVariables = Types.Exact<{
  input: Types.UpdateCustomerSendOrderEmailsInput;
}>;


export type UpdateCustomerSendOrderEmailsMutation = { __typename?: 'Mutation', updateCustomerSendOrderEmails: { __typename?: 'CustomerPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, description: string, currency: string, status: Types.CustomerStatus, sendOrderEmails: boolean, sendInvoiceEmails: boolean, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null } };

export type UpdateCustomerSendInvoiceEmailsMutationVariables = Types.Exact<{
  input: Types.UpdateCustomerSendInvoiceEmailsInput;
}>;


export type UpdateCustomerSendInvoiceEmailsMutation = { __typename?: 'Mutation', updateCustomerSendInvoiceEmails: { __typename?: 'CustomerPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, description: string, currency: string, status: Types.CustomerStatus, sendOrderEmails: boolean, sendInvoiceEmails: boolean, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null } };

export type SetCustomerTypeMutationVariables = Types.Exact<{
  input: Types.SetCustomerTypeInput;
}>;


export type SetCustomerTypeMutation = { __typename?: 'Mutation', setCustomerType: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', customerId: string, customerTypeId: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetCustomerDepositRequirementMutationVariables = Types.Exact<{
  input: Types.SetCustomerDepositRequirementInput;
}>;


export type SetCustomerDepositRequirementMutation = { __typename?: 'Mutation', setCustomerDepositRequirement: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', customerId: string, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateCustomerLocationSendOrderEmailsMutationVariables = Types.Exact<{
  input: Types.UpdateCustomerLocationSendOrderEmailsInput;
}>;


export type UpdateCustomerLocationSendOrderEmailsMutation = { __typename?: 'Mutation', updateCustomerLocationSendOrderEmails: { __typename?: 'CustomerPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, description: string, currency: string, status: Types.CustomerStatus, sendOrderEmails: boolean, sendInvoiceEmails: boolean, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null } };

export type UpdateCustomerLocationSendInvoiceEmailsMutationVariables = Types.Exact<{
  input: Types.UpdateCustomerLocationSendInvoiceEmailsInput;
}>;


export type UpdateCustomerLocationSendInvoiceEmailsMutation = { __typename?: 'Mutation', updateCustomerLocationSendInvoiceEmails: { __typename?: 'CustomerPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, description: string, currency: string, status: Types.CustomerStatus, sendOrderEmails: boolean, sendInvoiceEmails: boolean, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null } };

export type SetCustomerLocationServicingSiteMutationVariables = Types.Exact<{
  input: Types.SetCustomerLocationServicingSiteInput;
}>;


export type SetCustomerLocationServicingSiteMutation = { __typename?: 'Mutation', setCustomerLocationServicingSite: { __typename?: 'CustomerPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, description: string, currency: string, status: Types.CustomerStatus, sendOrderEmails: boolean, sendInvoiceEmails: boolean, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null } };

export type SetCustomerLocationCoordinatesMutationVariables = Types.Exact<{
  input: Types.SetCustomerLocationCoordinatesInput;
}>;


export type SetCustomerLocationCoordinatesMutation = { __typename?: 'Mutation', setCustomerLocationCoordinates: { __typename?: 'CustomerPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, description: string, currency: string, status: Types.CustomerStatus, sendOrderEmails: boolean, sendInvoiceEmails: boolean, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null } };

export type SetCustomerLocationReceivingEmailMutationVariables = Types.Exact<{
  input: Types.SetCustomerLocationReceivingEmailInput;
}>;


export type SetCustomerLocationReceivingEmailMutation = { __typename?: 'Mutation', setCustomerLocationReceivingEmail: { __typename?: 'CustomerPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, description: string, currency: string, status: Types.CustomerStatus, sendOrderEmails: boolean, sendInvoiceEmails: boolean, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null } };

export type SetCustomerLocationDeliveryScheduleMutationVariables = Types.Exact<{
  input: Types.SetCustomerLocationDeliveryScheduleInput;
}>;


export type SetCustomerLocationDeliveryScheduleMutation = { __typename?: 'Mutation', setCustomerLocationDeliverySchedule: { __typename?: 'CustomerLocationDeliverySchedulePayload', customerId: string, locationId: string, deliveryScheduleId: string, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ReplaceCustomerSalesPeopleMutationVariables = Types.Exact<{
  input: Types.ReplaceCustomerSalesPeopleInput;
}>;


export type ReplaceCustomerSalesPeopleMutation = { __typename?: 'Mutation', replaceCustomerSalesPeople: { __typename?: 'CustomerPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, description: string, currency: string, status: Types.CustomerStatus, sendOrderEmails: boolean, sendInvoiceEmails: boolean, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null } };

export type ReplaceLocationSalesPeopleMutationVariables = Types.Exact<{
  input: Types.ReplaceSalesPeopleInput;
}>;


export type ReplaceLocationSalesPeopleMutation = { __typename?: 'Mutation', replaceSalesPeople: { __typename?: 'CustomerPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, description: string, currency: string, status: Types.CustomerStatus, sendOrderEmails: boolean, sendInvoiceEmails: boolean, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null } };

export type SetLocationOrderEmailContactsMutationVariables = Types.Exact<{
  input: Types.SetLocationOrderEmailContactsInput;
}>;


export type SetLocationOrderEmailContactsMutation = { __typename?: 'Mutation', setLocationOrderEmailContacts: { __typename?: 'CustomerPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, description: string, currency: string, status: Types.CustomerStatus, sendOrderEmails: boolean, sendInvoiceEmails: boolean, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }> } | null } };

export type SetCustomerNoteMutationVariables = Types.Exact<{
  input: Types.SetCustomerNoteInput;
}>;


export type SetCustomerNoteMutation = { __typename?: 'Mutation', setCustomerNote: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, orderEmailContactIds: Array<string>, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearCustomerNoteMutationVariables = Types.Exact<{
  input: Types.ClearCustomerNoteInput;
}>;


export type ClearCustomerNoteMutation = { __typename?: 'Mutation', clearCustomerNote: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, orderEmailContactIds: Array<string>, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetCustomerLocationNoteMutationVariables = Types.Exact<{
  input: Types.SetCustomerLocationNoteInput;
}>;


export type SetCustomerLocationNoteMutation = { __typename?: 'Mutation', setCustomerLocationNote: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, orderEmailContactIds: Array<string>, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearCustomerLocationNoteMutationVariables = Types.Exact<{
  input: Types.ClearCustomerLocationNoteInput;
}>;


export type ClearCustomerLocationNoteMutation = { __typename?: 'Mutation', clearCustomerLocationNote: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, orderEmailContactIds: Array<string>, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddCustomerLocationSettingsNoteMutationVariables = Types.Exact<{
  input: Types.AddCustomerLocationSettingsNoteInput;
}>;


export type AddCustomerLocationSettingsNoteMutation = { __typename?: 'Mutation', addCustomerLocationSettingsNote: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, orderEmailContactIds: Array<string>, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type EditCustomerLocationSettingsNoteMutationVariables = Types.Exact<{
  input: Types.EditCustomerLocationSettingsNoteInput;
}>;


export type EditCustomerLocationSettingsNoteMutation = { __typename?: 'Mutation', editCustomerLocationSettingsNote: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, orderEmailContactIds: Array<string>, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetCustomerOrderEntryUnitMutationVariables = Types.Exact<{
  input: Types.SetCustomerOrderEntryUnitInput;
}>;


export type SetCustomerOrderEntryUnitMutation = { __typename?: 'Mutation', setCustomerOrderEntryUnit: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', customerId: string, orderEntryUnit?: Types.OrderEntryUnit | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetCustomerPriceEntryUnitMutationVariables = Types.Exact<{
  input: Types.SetCustomerPriceEntryUnitInput;
}>;


export type SetCustomerPriceEntryUnitMutation = { __typename?: 'Mutation', setCustomerPriceEntryUnit: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, orderEmailContactIds: Array<string>, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetCustomerDisabledVolumePoolsMutationVariables = Types.Exact<{
  input: Types.SetCustomerDisabledVolumePoolsInput;
}>;


export type SetCustomerDisabledVolumePoolsMutation = { __typename?: 'Mutation', setCustomerDisabledVolumePools: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', customerId: string, disabledVolumePoolIds: Array<string>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetCustomerStatementDeliveryMutationVariables = Types.Exact<{
  input: Types.SetCustomerStatementDeliveryInput;
}>;


export type SetCustomerStatementDeliveryMutation = { __typename?: 'Mutation', setCustomerStatementDelivery: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', customerId: string, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetCustomerTaxDetailsMutationVariables = Types.Exact<{
  input: Types.SetCustomerTaxDetailsInput;
}>;


export type SetCustomerTaxDetailsMutation = { __typename?: 'Mutation', setCustomerTaxDetails: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, orderEmailContactIds: Array<string>, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetCustomerMinimumFreightChargeMutationVariables = Types.Exact<{
  input: Types.SetCustomerMinimumFreightChargeInput;
}>;


export type SetCustomerMinimumFreightChargeMutation = { __typename?: 'Mutation', setCustomerMinimumFreightCharge: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, orderEmailContactIds: Array<string>, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ImportUpsertCustomerMutationVariables = Types.Exact<{
  input: Types.UpsertCustomerInput;
}>;


export type ImportUpsertCustomerMutation = { __typename?: 'Mutation', upsertCustomer: { __typename?: 'UpsertCustomerPayload', customer?: { __typename?: 'CustomerStateData', customerId: string } | null, locations?: { __typename?: 'UpsertChildCountsData', inserted: number, updated: number, unchanged: number } | null, billingAddresses?: { __typename?: 'UpsertChildCountsData', inserted: number, updated: number, unchanged: number } | null, contacts?: { __typename?: 'UpsertChildCountsData', inserted: number, updated: number, unchanged: number } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpsertLocationsMutationVariables = Types.Exact<{
  input: Types.UpsertLocationsInput;
}>;


export type UpsertLocationsMutation = { __typename?: 'Mutation', upsertLocations: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', customerId: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpsertBillingAddressesMutationVariables = Types.Exact<{
  input: Types.UpsertBillingAddressesInput;
}>;


export type UpsertBillingAddressesMutation = { __typename?: 'Mutation', upsertBillingAddresses: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', customerId: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpsertContactsMutationVariables = Types.Exact<{
  input: Types.UpsertContactsInput;
}>;


export type UpsertContactsMutation = { __typename?: 'Mutation', upsertContacts: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', customerId: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddCustomerUpgradeMutationVariables = Types.Exact<{
  input: Types.AddCustomerUpgradeInput;
}>;


export type AddCustomerUpgradeMutation = { __typename?: 'Mutation', addCustomerUpgrade: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, orderEmailContactIds: Array<string>, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateCustomerUpgradeMutationVariables = Types.Exact<{
  input: Types.UpdateCustomerUpgradeInput;
}>;


export type UpdateCustomerUpgradeMutation = { __typename?: 'Mutation', updateCustomerUpgrade: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, orderEmailContactIds: Array<string>, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ToggleCustomerUpgradeDefaultMutationVariables = Types.Exact<{
  input: Types.ToggleCustomerUpgradeDefaultInput;
}>;


export type ToggleCustomerUpgradeDefaultMutation = { __typename?: 'Mutation', toggleCustomerUpgradeDefault: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, orderEmailContactIds: Array<string>, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeactivateCustomerUpgradeMutationVariables = Types.Exact<{
  input: Types.DeactivateCustomerUpgradeInput;
}>;


export type DeactivateCustomerUpgradeMutation = { __typename?: 'Mutation', deactivateCustomerUpgrade: { __typename?: 'CustomerPayload', customer?: { __typename?: 'CustomerStateData', tenantId: string, customerId: string, name: string, currency: string, status: Types.CustomerStatus, description: string, erpId: string, crmRecordUrl: string, erpPriceGroupId: string, priceGroupId: string, priceGroupName: string, termsId: string, termsName: string, customerTypeId: string, customerGroupId: string, route: string, carrier: string, allowOrderBillingAddressEdit: boolean, allowOrderLocationAddressEdit: boolean, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, defaultDiscountPercentage?: number | null, depositRequirementType?: Types.DepositRequirementType | null, depositRequirementValue?: number | null, taxExemptNumber: string, federalTaxNumber: string, sendOrderEmails: boolean, sendInvoiceEmails: boolean, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, poRequired: boolean, synchronizeOrders: boolean, customerLookupCode: string, orderEntryUnit?: Types.OrderEntryUnit | null, effectiveOrderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, effectivePriceEntryUnit: Types.PriceEntryUnit, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, effectiveStatementDeliveryMethod: Types.StatementDeliveryMethod, effectiveStatementSkipZeroBalance: boolean, disabledVolumePoolIds: Array<string>, taxExemptions: Array<{ __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, certificateNumber: string, expiresOn?: string | null }>, disabledVolumePools: Array<{ __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null }>, contextNotes: Array<{ __typename?: 'CustomerContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, locations: Array<{ __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, defaultContactId?: string | null, effectiveContactId?: string | null, effectiveContactInherited: boolean, orderEmailContactIds: Array<string>, receivingWindowStart?: string | null, receivingWindowEnd?: string | null, unloadMinutes?: number | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }>, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, contacts: Array<{ __typename?: 'ContactData', id: string, firstName: string, lastName: string, title: string, type: Types.ContactType, status: Types.ContactStatus, importId: string, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }> }>, upgrades: Array<{ __typename?: 'CustomerUpgrade', upgradeId: string, appliesToItemId?: string | null, name: string, categoryLabel?: string | null, isDefault: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const AddCustomerDocument = new TypedDocumentString(`
    mutation AddCustomer($input: AddCustomerInput!) {
  createCustomer(input: $input) {
    ...ChangedCustomer
    customer {
      allowOrderBillingAddressEdit
      allowOrderLocationAddressEdit
    }
    errors {
      code
      message
    }
  }
}
    fragment ChangedCustomer on CustomerPayload {
  customer {
    tenantId
    customerId
    name
    description
    currency
    status
    sendOrderEmails
    sendInvoiceEmails
    salesPeople {
      ...SalesPerson
    }
    locations {
      ...Location
    }
  }
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const EditCustomerDocument = new TypedDocumentString(`
    mutation EditCustomer($input: EditCustomerInput!) {
  updateCustomer(input: $input) {
    ...ChangedCustomer
    customer {
      allowOrderBillingAddressEdit
      allowOrderLocationAddressEdit
    }
    errors {
      code
      message
    }
  }
}
    fragment ChangedCustomer on CustomerPayload {
  customer {
    tenantId
    customerId
    name
    description
    currency
    status
    sendOrderEmails
    sendInvoiceEmails
    salesPeople {
      ...SalesPerson
    }
    locations {
      ...Location
    }
  }
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const AddLocationDocument = new TypedDocumentString(`
    mutation AddLocation($input: AddLocationInput!) {
  addLocation(input: $input) {
    customer {
      tenantId
      customerId
      locations {
        ...Location
      }
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const RemoveLocationDocument = new TypedDocumentString(`
    mutation RemoveLocation($input: RemoveLocationInput!) {
  removeLocation(input: $input) {
    customer {
      tenantId
      customerId
      locations {
        ...Location
      }
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const UpdateLocationDocument = new TypedDocumentString(`
    mutation UpdateLocation($input: UpdateLocationInput!) {
  updateLocation(input: $input) {
    customer {
      tenantId
      customerId
      locations {
        ...Location
      }
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const AddContactDocument = new TypedDocumentString(`
    mutation AddContact($input: AddContactInput!) {
  addContact(input: $input) {
    ...ChangedCustomer
    errors {
      code
      message
    }
  }
}
    fragment ChangedCustomer on CustomerPayload {
  customer {
    tenantId
    customerId
    name
    description
    currency
    status
    sendOrderEmails
    sendInvoiceEmails
    salesPeople {
      ...SalesPerson
    }
    locations {
      ...Location
    }
  }
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const UpdateContactDocument = new TypedDocumentString(`
    mutation UpdateContact($input: UpdateContactInput!) {
  updateContact(input: $input) {
    ...ChangedCustomer
    errors {
      code
      message
    }
  }
}
    fragment ChangedCustomer on CustomerPayload {
  customer {
    tenantId
    customerId
    name
    description
    currency
    status
    sendOrderEmails
    sendInvoiceEmails
    salesPeople {
      ...SalesPerson
    }
    locations {
      ...Location
    }
  }
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const RemoveContactDocument = new TypedDocumentString(`
    mutation RemoveContact($input: RemoveContactInput!) {
  removeContact(input: $input) {
    ...ChangedCustomer
    errors {
      code
      message
    }
  }
}
    fragment ChangedCustomer on CustomerPayload {
  customer {
    tenantId
    customerId
    name
    description
    currency
    status
    sendOrderEmails
    sendInvoiceEmails
    salesPeople {
      ...SalesPerson
    }
    locations {
      ...Location
    }
  }
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const AddBillingAddressDocument = new TypedDocumentString(`
    mutation AddBillingAddress($input: AddBillingAddressInput!) {
  addBillingAddress(input: $input) {
    customer {
      tenantId
      customerId
      billingAddresses {
        ...Address
      }
    }
    errors {
      code
      message
    }
  }
}
    fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const RemoveBillingAddressDocument = new TypedDocumentString(`
    mutation RemoveBillingAddress($input: RemoveBillingAddressInput!) {
  removeBillingAddress(input: $input) {
    customer {
      tenantId
      customerId
      billingAddresses {
        ...Address
      }
    }
    errors {
      code
      message
    }
  }
}
    fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const UpdateBillingAddressDocument = new TypedDocumentString(`
    mutation UpdateBillingAddress($input: UpdateBillingAddressInput!) {
  updateBillingAddress(input: $input) {
    customer {
      tenantId
      customerId
      billingAddresses {
        ...Address
      }
    }
    errors {
      code
      message
    }
  }
}
    fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const InactivateCustomerDocument = new TypedDocumentString(`
    mutation InactivateCustomer($input: InactivateCustomerInput!) {
  inactivateCustomer(input: $input) {
    customer {
      ...Customer
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
  orderEmailContactIds
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}`);
export const ActivateCustomerDocument = new TypedDocumentString(`
    mutation ActivateCustomer($input: ActivateCustomerInput!) {
  activateCustomer(input: $input) {
    customer {
      ...Customer
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
  orderEmailContactIds
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}`);
export const DeleteCustomerDocument = new TypedDocumentString(`
    mutation DeleteCustomer($input: DeleteCustomerInput!) {
  deleteCustomer(input: $input) {
    customer {
      ...Customer
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
  orderEmailContactIds
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}`);
export const BatchInactivateCustomersDocument = new TypedDocumentString(`
    mutation BatchInactivateCustomers($input: BatchInactivateCustomersInput!) {
  batchInactivateCustomers(input: $input) {
    customers {
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
export const BatchActivateCustomersDocument = new TypedDocumentString(`
    mutation BatchActivateCustomers($input: BatchActivateCustomersInput!) {
  batchActivateCustomers(input: $input) {
    customers {
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
export const BatchDeleteCustomersDocument = new TypedDocumentString(`
    mutation BatchDeleteCustomers($input: BatchDeleteCustomersInput!) {
  batchDeleteCustomers(input: $input) {
    customers {
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
export const MergeCustomerDocument = new TypedDocumentString(`
    mutation mergeCustomer($input: MergeCustomerInput!) {
  mergeCustomer(input: $input) {
    errors {
      code
      message
    }
    customer {
      ...Customer
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
  orderEmailContactIds
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}`);
export const UpdateCustomerOrderAddressEditPermissionsDocument = new TypedDocumentString(`
    mutation UpdateCustomerOrderAddressEditPermissions($input: UpdateCustomerOrderAddressEditPermissionsInput!) {
  updateCustomerOrderAddressEditPermissions(input: $input) {
    customer {
      customerId
      allowOrderBillingAddressEdit
      allowOrderLocationAddressEdit
    }
    errors {
      code
      message
    }
  }
}
    `);
export const UpdateCustomerLocationOrderAddressEditPermissionsDocument = new TypedDocumentString(`
    mutation UpdateCustomerLocationOrderAddressEditPermissions($input: UpdateCustomerLocationOrderAddressEditPermissionsInput!) {
  updateCustomerLocationOrderAddressEditPermissions(input: $input) {
    customer {
      customerId
      locations {
        id
        allowOrderBillingAddressEdit
        allowOrderLocationAddressEdit
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
export const UpdateCustomerSendOrderEmailsDocument = new TypedDocumentString(`
    mutation UpdateCustomerSendOrderEmails($input: UpdateCustomerSendOrderEmailsInput!) {
  updateCustomerSendOrderEmails(input: $input) {
    ...ChangedCustomer
    errors {
      code
      message
    }
  }
}
    fragment ChangedCustomer on CustomerPayload {
  customer {
    tenantId
    customerId
    name
    description
    currency
    status
    sendOrderEmails
    sendInvoiceEmails
    salesPeople {
      ...SalesPerson
    }
    locations {
      ...Location
    }
  }
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const UpdateCustomerSendInvoiceEmailsDocument = new TypedDocumentString(`
    mutation UpdateCustomerSendInvoiceEmails($input: UpdateCustomerSendInvoiceEmailsInput!) {
  updateCustomerSendInvoiceEmails(input: $input) {
    ...ChangedCustomer
    errors {
      code
      message
    }
  }
}
    fragment ChangedCustomer on CustomerPayload {
  customer {
    tenantId
    customerId
    name
    description
    currency
    status
    sendOrderEmails
    sendInvoiceEmails
    salesPeople {
      ...SalesPerson
    }
    locations {
      ...Location
    }
  }
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const SetCustomerTypeDocument = new TypedDocumentString(`
    mutation SetCustomerType($input: SetCustomerTypeInput!) {
  setCustomerType(input: $input) {
    customer {
      customerId
      customerTypeId
    }
    errors {
      code
      message
    }
  }
}
    `);
export const SetCustomerDepositRequirementDocument = new TypedDocumentString(`
    mutation SetCustomerDepositRequirement($input: SetCustomerDepositRequirementInput!) {
  setCustomerDepositRequirement(input: $input) {
    customer {
      customerId
      depositRequirementType
      depositRequirementValue
    }
    errors {
      code
      message
    }
  }
}
    `);
export const UpdateCustomerLocationSendOrderEmailsDocument = new TypedDocumentString(`
    mutation UpdateCustomerLocationSendOrderEmails($input: UpdateCustomerLocationSendOrderEmailsInput!) {
  updateCustomerLocationSendOrderEmails(input: $input) {
    ...ChangedCustomer
    errors {
      code
      message
    }
  }
}
    fragment ChangedCustomer on CustomerPayload {
  customer {
    tenantId
    customerId
    name
    description
    currency
    status
    sendOrderEmails
    sendInvoiceEmails
    salesPeople {
      ...SalesPerson
    }
    locations {
      ...Location
    }
  }
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const UpdateCustomerLocationSendInvoiceEmailsDocument = new TypedDocumentString(`
    mutation UpdateCustomerLocationSendInvoiceEmails($input: UpdateCustomerLocationSendInvoiceEmailsInput!) {
  updateCustomerLocationSendInvoiceEmails(input: $input) {
    ...ChangedCustomer
    errors {
      code
      message
    }
  }
}
    fragment ChangedCustomer on CustomerPayload {
  customer {
    tenantId
    customerId
    name
    description
    currency
    status
    sendOrderEmails
    sendInvoiceEmails
    salesPeople {
      ...SalesPerson
    }
    locations {
      ...Location
    }
  }
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const SetCustomerLocationServicingSiteDocument = new TypedDocumentString(`
    mutation SetCustomerLocationServicingSite($input: SetCustomerLocationServicingSiteInput!) {
  setCustomerLocationServicingSite(input: $input) {
    ...ChangedCustomer
    errors {
      code
      message
    }
  }
}
    fragment ChangedCustomer on CustomerPayload {
  customer {
    tenantId
    customerId
    name
    description
    currency
    status
    sendOrderEmails
    sendInvoiceEmails
    salesPeople {
      ...SalesPerson
    }
    locations {
      ...Location
    }
  }
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const SetCustomerLocationCoordinatesDocument = new TypedDocumentString(`
    mutation SetCustomerLocationCoordinates($input: SetCustomerLocationCoordinatesInput!) {
  setCustomerLocationCoordinates(input: $input) {
    ...ChangedCustomer
    errors {
      code
      message
    }
  }
}
    fragment ChangedCustomer on CustomerPayload {
  customer {
    tenantId
    customerId
    name
    description
    currency
    status
    sendOrderEmails
    sendInvoiceEmails
    salesPeople {
      ...SalesPerson
    }
    locations {
      ...Location
    }
  }
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const SetCustomerLocationReceivingEmailDocument = new TypedDocumentString(`
    mutation SetCustomerLocationReceivingEmail($input: SetCustomerLocationReceivingEmailInput!) {
  setCustomerLocationReceivingEmail(input: $input) {
    ...ChangedCustomer
    errors {
      code
      message
    }
  }
}
    fragment ChangedCustomer on CustomerPayload {
  customer {
    tenantId
    customerId
    name
    description
    currency
    status
    sendOrderEmails
    sendInvoiceEmails
    salesPeople {
      ...SalesPerson
    }
    locations {
      ...Location
    }
  }
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const SetCustomerLocationDeliveryScheduleDocument = new TypedDocumentString(`
    mutation SetCustomerLocationDeliverySchedule($input: SetCustomerLocationDeliveryScheduleInput!) {
  setCustomerLocationDeliverySchedule(input: $input) {
    customerId
    locationId
    deliveryScheduleId
    errors {
      code
      message
    }
  }
}
    `);
export const ReplaceCustomerSalesPeopleDocument = new TypedDocumentString(`
    mutation ReplaceCustomerSalesPeople($input: ReplaceCustomerSalesPeopleInput!) {
  replaceCustomerSalesPeople(input: $input) {
    ...ChangedCustomer
    errors {
      code
      message
    }
  }
}
    fragment ChangedCustomer on CustomerPayload {
  customer {
    tenantId
    customerId
    name
    description
    currency
    status
    sendOrderEmails
    sendInvoiceEmails
    salesPeople {
      ...SalesPerson
    }
    locations {
      ...Location
    }
  }
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const ReplaceLocationSalesPeopleDocument = new TypedDocumentString(`
    mutation ReplaceLocationSalesPeople($input: ReplaceSalesPeopleInput!) {
  replaceSalesPeople(input: $input) {
    ...ChangedCustomer
    errors {
      code
      message
    }
  }
}
    fragment ChangedCustomer on CustomerPayload {
  customer {
    tenantId
    customerId
    name
    description
    currency
    status
    sendOrderEmails
    sendInvoiceEmails
    salesPeople {
      ...SalesPerson
    }
    locations {
      ...Location
    }
  }
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const SetLocationOrderEmailContactsDocument = new TypedDocumentString(`
    mutation SetLocationOrderEmailContacts($input: SetLocationOrderEmailContactsInput!) {
  setLocationOrderEmailContacts(input: $input) {
    ...ChangedCustomer
    errors {
      code
      message
    }
  }
}
    fragment ChangedCustomer on CustomerPayload {
  customer {
    tenantId
    customerId
    name
    description
    currency
    status
    sendOrderEmails
    sendInvoiceEmails
    salesPeople {
      ...SalesPerson
    }
    locations {
      ...Location
    }
  }
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const SetCustomerNoteDocument = new TypedDocumentString(`
    mutation SetCustomerNote($input: SetCustomerNoteInput!) {
  setCustomerNote(input: $input) {
    customer {
      ...Customer
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
  orderEmailContactIds
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}`);
export const ClearCustomerNoteDocument = new TypedDocumentString(`
    mutation ClearCustomerNote($input: ClearCustomerNoteInput!) {
  clearCustomerNote(input: $input) {
    customer {
      ...Customer
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
  orderEmailContactIds
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}`);
export const SetCustomerLocationNoteDocument = new TypedDocumentString(`
    mutation SetCustomerLocationNote($input: SetCustomerLocationNoteInput!) {
  setCustomerLocationNote(input: $input) {
    customer {
      ...Customer
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
  orderEmailContactIds
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}`);
export const ClearCustomerLocationNoteDocument = new TypedDocumentString(`
    mutation ClearCustomerLocationNote($input: ClearCustomerLocationNoteInput!) {
  clearCustomerLocationNote(input: $input) {
    customer {
      ...Customer
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
  orderEmailContactIds
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}`);
export const AddCustomerLocationSettingsNoteDocument = new TypedDocumentString(`
    mutation AddCustomerLocationSettingsNote($input: AddCustomerLocationSettingsNoteInput!) {
  addCustomerLocationSettingsNote(input: $input) {
    customer {
      ...Customer
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
  orderEmailContactIds
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}`);
export const EditCustomerLocationSettingsNoteDocument = new TypedDocumentString(`
    mutation EditCustomerLocationSettingsNote($input: EditCustomerLocationSettingsNoteInput!) {
  editCustomerLocationSettingsNote(input: $input) {
    customer {
      ...Customer
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
  orderEmailContactIds
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}`);
export const SetCustomerOrderEntryUnitDocument = new TypedDocumentString(`
    mutation SetCustomerOrderEntryUnit($input: SetCustomerOrderEntryUnitInput!) {
  setCustomerOrderEntryUnit(input: $input) {
    customer {
      customerId
      orderEntryUnit
    }
    errors {
      code
      message
    }
  }
}
    `);
export const SetCustomerPriceEntryUnitDocument = new TypedDocumentString(`
    mutation SetCustomerPriceEntryUnit($input: SetCustomerPriceEntryUnitInput!) {
  setCustomerPriceEntryUnit(input: $input) {
    customer {
      ...Customer
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
  orderEmailContactIds
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}`);
export const SetCustomerDisabledVolumePoolsDocument = new TypedDocumentString(`
    mutation SetCustomerDisabledVolumePools($input: SetCustomerDisabledVolumePoolsInput!) {
  setCustomerDisabledVolumePools(input: $input) {
    customer {
      customerId
      disabledVolumePoolIds
      disabledVolumePools {
        ...VolumePool
      }
    }
    errors {
      code
      message
    }
  }
}
    fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}`);
export const SetCustomerStatementDeliveryDocument = new TypedDocumentString(`
    mutation SetCustomerStatementDelivery($input: SetCustomerStatementDeliveryInput!) {
  setCustomerStatementDelivery(input: $input) {
    customer {
      customerId
      statementDeliveryMethod
      statementSkipZeroBalance
      effectiveStatementDeliveryMethod
      effectiveStatementSkipZeroBalance
    }
    errors {
      code
      message
    }
  }
}
    `);
export const SetCustomerTaxDetailsDocument = new TypedDocumentString(`
    mutation SetCustomerTaxDetails($input: SetCustomerTaxDetailsInput!) {
  setCustomerTaxDetails(input: $input) {
    customer {
      ...Customer
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
  orderEmailContactIds
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}`);
export const SetCustomerMinimumFreightChargeDocument = new TypedDocumentString(`
    mutation SetCustomerMinimumFreightCharge($input: SetCustomerMinimumFreightChargeInput!) {
  setCustomerMinimumFreightCharge(input: $input) {
    customer {
      ...Customer
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
  orderEmailContactIds
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}`);
export const ImportUpsertCustomerDocument = new TypedDocumentString(`
    mutation ImportUpsertCustomer($input: UpsertCustomerInput!) {
  upsertCustomer(input: $input) {
    customer {
      ...CustomerIdentity
    }
    locations {
      inserted
      updated
      unchanged
    }
    billingAddresses {
      inserted
      updated
      unchanged
    }
    contacts {
      inserted
      updated
      unchanged
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerIdentity on CustomerStateData {
  customerId
}`);
export const UpsertLocationsDocument = new TypedDocumentString(`
    mutation UpsertLocations($input: UpsertLocationsInput!) {
  upsertLocations(input: $input) {
    customer {
      ...CustomerIdentity
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerIdentity on CustomerStateData {
  customerId
}`);
export const UpsertBillingAddressesDocument = new TypedDocumentString(`
    mutation UpsertBillingAddresses($input: UpsertBillingAddressesInput!) {
  upsertBillingAddresses(input: $input) {
    customer {
      ...CustomerIdentity
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerIdentity on CustomerStateData {
  customerId
}`);
export const UpsertContactsDocument = new TypedDocumentString(`
    mutation UpsertContacts($input: UpsertContactsInput!) {
  upsertContacts(input: $input) {
    customer {
      ...CustomerIdentity
    }
    errors {
      code
      message
    }
  }
}
    fragment CustomerIdentity on CustomerStateData {
  customerId
}`);
export const AddCustomerUpgradeDocument = new TypedDocumentString(`
    mutation AddCustomerUpgrade($input: AddCustomerUpgradeInput!) {
  addCustomerUpgrade(input: $input) {
    customer {
      ...Customer
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
  orderEmailContactIds
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}`);
export const UpdateCustomerUpgradeDocument = new TypedDocumentString(`
    mutation UpdateCustomerUpgrade($input: UpdateCustomerUpgradeInput!) {
  updateCustomerUpgrade(input: $input) {
    customer {
      ...Customer
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
  orderEmailContactIds
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}`);
export const ToggleCustomerUpgradeDefaultDocument = new TypedDocumentString(`
    mutation ToggleCustomerUpgradeDefault($input: ToggleCustomerUpgradeDefaultInput!) {
  toggleCustomerUpgradeDefault(input: $input) {
    customer {
      ...Customer
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
  orderEmailContactIds
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}`);
export const DeactivateCustomerUpgradeDocument = new TypedDocumentString(`
    mutation DeactivateCustomerUpgrade($input: DeactivateCustomerUpgradeInput!) {
  deactivateCustomerUpgrade(input: $input) {
    customer {
      ...Customer
    }
    errors {
      code
      message
    }
  }
}
    fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Customer on CustomerStateData {
  tenantId
  customerId
  name
  currency
  status
  description
  erpId
  crmRecordUrl
  erpPriceGroupId
  priceGroupId
  priceGroupName
  termsId
  termsName
  customerTypeId
  customerGroupId
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  defaultDiscountPercentage
  depositRequirementType
  depositRequirementValue
  taxExemptNumber
  federalTaxNumber
  taxExemptions {
    ...CustomerTaxExemption
  }
  sendOrderEmails
  sendInvoiceEmails
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
  poRequired
  synchronizeOrders
  customerLookupCode
  orderEntryUnit
  effectiveOrderEntryUnit
  priceEntryUnit
  effectivePriceEntryUnit
  statementDeliveryMethod
  statementSkipZeroBalance
  effectiveStatementDeliveryMethod
  effectiveStatementSkipZeroBalance
  disabledVolumePoolIds
  disabledVolumePools {
    ...VolumePool
  }
  contextNotes {
    context
    text
    submitDate
    submittedBy
  }
  salesPeople {
    ...SalesPerson
  }
  shipFromLocations {
    name
  }
  locations {
    ...Location
    ...LocationDefaultContact
    ...LocationReceivingHours
  }
  billingAddresses {
    ...BillingAddresses
  }
  contacts {
    ...Contact
  }
  upgrades {
    ...CustomerUpgradeFields
  }
  orderSubmitter {
    ...OrderSubmitter
  }
}
fragment CustomerTaxExemption on CustomerTaxExemption {
  state
  reason
  certificateNumber
  expiresOn
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}
fragment LocationDefaultContact on LocationData {
  defaultContactId
  effectiveContactId
  effectiveContactInherited
  orderEmailContactIds
}
fragment LocationReceivingHours on LocationData {
  receivingWindowStart
  receivingWindowEnd
  unloadMinutes
}
fragment BillingAddresses on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Contact on ContactData {
  id
  firstName
  lastName
  title
  type
  status
  importId
  emailAddresses {
    type
    value
  }
  phoneNumbers {
    type
    value
  }
}
fragment CustomerUpgradeFields on CustomerUpgrade {
  upgradeId
  appliesToItemId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  status
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AddCustomer: build.mutation<AddCustomerMutation, AddCustomerMutationVariables>({
      query: (variables) => ({ document: AddCustomerDocument, variables })
    }),
    EditCustomer: build.mutation<EditCustomerMutation, EditCustomerMutationVariables>({
      query: (variables) => ({ document: EditCustomerDocument, variables })
    }),
    AddLocation: build.mutation<AddLocationMutation, AddLocationMutationVariables>({
      query: (variables) => ({ document: AddLocationDocument, variables })
    }),
    RemoveLocation: build.mutation<RemoveLocationMutation, RemoveLocationMutationVariables>({
      query: (variables) => ({ document: RemoveLocationDocument, variables })
    }),
    UpdateLocation: build.mutation<UpdateLocationMutation, UpdateLocationMutationVariables>({
      query: (variables) => ({ document: UpdateLocationDocument, variables })
    }),
    AddContact: build.mutation<AddContactMutation, AddContactMutationVariables>({
      query: (variables) => ({ document: AddContactDocument, variables })
    }),
    UpdateContact: build.mutation<UpdateContactMutation, UpdateContactMutationVariables>({
      query: (variables) => ({ document: UpdateContactDocument, variables })
    }),
    RemoveContact: build.mutation<RemoveContactMutation, RemoveContactMutationVariables>({
      query: (variables) => ({ document: RemoveContactDocument, variables })
    }),
    AddBillingAddress: build.mutation<AddBillingAddressMutation, AddBillingAddressMutationVariables>({
      query: (variables) => ({ document: AddBillingAddressDocument, variables })
    }),
    RemoveBillingAddress: build.mutation<RemoveBillingAddressMutation, RemoveBillingAddressMutationVariables>({
      query: (variables) => ({ document: RemoveBillingAddressDocument, variables })
    }),
    UpdateBillingAddress: build.mutation<UpdateBillingAddressMutation, UpdateBillingAddressMutationVariables>({
      query: (variables) => ({ document: UpdateBillingAddressDocument, variables })
    }),
    InactivateCustomer: build.mutation<InactivateCustomerMutation, InactivateCustomerMutationVariables>({
      query: (variables) => ({ document: InactivateCustomerDocument, variables })
    }),
    ActivateCustomer: build.mutation<ActivateCustomerMutation, ActivateCustomerMutationVariables>({
      query: (variables) => ({ document: ActivateCustomerDocument, variables })
    }),
    DeleteCustomer: build.mutation<DeleteCustomerMutation, DeleteCustomerMutationVariables>({
      query: (variables) => ({ document: DeleteCustomerDocument, variables })
    }),
    BatchInactivateCustomers: build.mutation<BatchInactivateCustomersMutation, BatchInactivateCustomersMutationVariables>({
      query: (variables) => ({ document: BatchInactivateCustomersDocument, variables })
    }),
    BatchActivateCustomers: build.mutation<BatchActivateCustomersMutation, BatchActivateCustomersMutationVariables>({
      query: (variables) => ({ document: BatchActivateCustomersDocument, variables })
    }),
    BatchDeleteCustomers: build.mutation<BatchDeleteCustomersMutation, BatchDeleteCustomersMutationVariables>({
      query: (variables) => ({ document: BatchDeleteCustomersDocument, variables })
    }),
    mergeCustomer: build.mutation<MergeCustomerMutation, MergeCustomerMutationVariables>({
      query: (variables) => ({ document: MergeCustomerDocument, variables })
    }),
    UpdateCustomerOrderAddressEditPermissions: build.mutation<UpdateCustomerOrderAddressEditPermissionsMutation, UpdateCustomerOrderAddressEditPermissionsMutationVariables>({
      query: (variables) => ({ document: UpdateCustomerOrderAddressEditPermissionsDocument, variables })
    }),
    UpdateCustomerLocationOrderAddressEditPermissions: build.mutation<UpdateCustomerLocationOrderAddressEditPermissionsMutation, UpdateCustomerLocationOrderAddressEditPermissionsMutationVariables>({
      query: (variables) => ({ document: UpdateCustomerLocationOrderAddressEditPermissionsDocument, variables })
    }),
    UpdateCustomerSendOrderEmails: build.mutation<UpdateCustomerSendOrderEmailsMutation, UpdateCustomerSendOrderEmailsMutationVariables>({
      query: (variables) => ({ document: UpdateCustomerSendOrderEmailsDocument, variables })
    }),
    UpdateCustomerSendInvoiceEmails: build.mutation<UpdateCustomerSendInvoiceEmailsMutation, UpdateCustomerSendInvoiceEmailsMutationVariables>({
      query: (variables) => ({ document: UpdateCustomerSendInvoiceEmailsDocument, variables })
    }),
    SetCustomerType: build.mutation<SetCustomerTypeMutation, SetCustomerTypeMutationVariables>({
      query: (variables) => ({ document: SetCustomerTypeDocument, variables })
    }),
    SetCustomerDepositRequirement: build.mutation<SetCustomerDepositRequirementMutation, SetCustomerDepositRequirementMutationVariables>({
      query: (variables) => ({ document: SetCustomerDepositRequirementDocument, variables })
    }),
    UpdateCustomerLocationSendOrderEmails: build.mutation<UpdateCustomerLocationSendOrderEmailsMutation, UpdateCustomerLocationSendOrderEmailsMutationVariables>({
      query: (variables) => ({ document: UpdateCustomerLocationSendOrderEmailsDocument, variables })
    }),
    UpdateCustomerLocationSendInvoiceEmails: build.mutation<UpdateCustomerLocationSendInvoiceEmailsMutation, UpdateCustomerLocationSendInvoiceEmailsMutationVariables>({
      query: (variables) => ({ document: UpdateCustomerLocationSendInvoiceEmailsDocument, variables })
    }),
    SetCustomerLocationServicingSite: build.mutation<SetCustomerLocationServicingSiteMutation, SetCustomerLocationServicingSiteMutationVariables>({
      query: (variables) => ({ document: SetCustomerLocationServicingSiteDocument, variables })
    }),
    SetCustomerLocationCoordinates: build.mutation<SetCustomerLocationCoordinatesMutation, SetCustomerLocationCoordinatesMutationVariables>({
      query: (variables) => ({ document: SetCustomerLocationCoordinatesDocument, variables })
    }),
    SetCustomerLocationReceivingEmail: build.mutation<SetCustomerLocationReceivingEmailMutation, SetCustomerLocationReceivingEmailMutationVariables>({
      query: (variables) => ({ document: SetCustomerLocationReceivingEmailDocument, variables })
    }),
    SetCustomerLocationDeliverySchedule: build.mutation<SetCustomerLocationDeliveryScheduleMutation, SetCustomerLocationDeliveryScheduleMutationVariables>({
      query: (variables) => ({ document: SetCustomerLocationDeliveryScheduleDocument, variables })
    }),
    ReplaceCustomerSalesPeople: build.mutation<ReplaceCustomerSalesPeopleMutation, ReplaceCustomerSalesPeopleMutationVariables>({
      query: (variables) => ({ document: ReplaceCustomerSalesPeopleDocument, variables })
    }),
    ReplaceLocationSalesPeople: build.mutation<ReplaceLocationSalesPeopleMutation, ReplaceLocationSalesPeopleMutationVariables>({
      query: (variables) => ({ document: ReplaceLocationSalesPeopleDocument, variables })
    }),
    SetLocationOrderEmailContacts: build.mutation<SetLocationOrderEmailContactsMutation, SetLocationOrderEmailContactsMutationVariables>({
      query: (variables) => ({ document: SetLocationOrderEmailContactsDocument, variables })
    }),
    SetCustomerNote: build.mutation<SetCustomerNoteMutation, SetCustomerNoteMutationVariables>({
      query: (variables) => ({ document: SetCustomerNoteDocument, variables })
    }),
    ClearCustomerNote: build.mutation<ClearCustomerNoteMutation, ClearCustomerNoteMutationVariables>({
      query: (variables) => ({ document: ClearCustomerNoteDocument, variables })
    }),
    SetCustomerLocationNote: build.mutation<SetCustomerLocationNoteMutation, SetCustomerLocationNoteMutationVariables>({
      query: (variables) => ({ document: SetCustomerLocationNoteDocument, variables })
    }),
    ClearCustomerLocationNote: build.mutation<ClearCustomerLocationNoteMutation, ClearCustomerLocationNoteMutationVariables>({
      query: (variables) => ({ document: ClearCustomerLocationNoteDocument, variables })
    }),
    AddCustomerLocationSettingsNote: build.mutation<AddCustomerLocationSettingsNoteMutation, AddCustomerLocationSettingsNoteMutationVariables>({
      query: (variables) => ({ document: AddCustomerLocationSettingsNoteDocument, variables })
    }),
    EditCustomerLocationSettingsNote: build.mutation<EditCustomerLocationSettingsNoteMutation, EditCustomerLocationSettingsNoteMutationVariables>({
      query: (variables) => ({ document: EditCustomerLocationSettingsNoteDocument, variables })
    }),
    SetCustomerOrderEntryUnit: build.mutation<SetCustomerOrderEntryUnitMutation, SetCustomerOrderEntryUnitMutationVariables>({
      query: (variables) => ({ document: SetCustomerOrderEntryUnitDocument, variables })
    }),
    SetCustomerPriceEntryUnit: build.mutation<SetCustomerPriceEntryUnitMutation, SetCustomerPriceEntryUnitMutationVariables>({
      query: (variables) => ({ document: SetCustomerPriceEntryUnitDocument, variables })
    }),
    SetCustomerDisabledVolumePools: build.mutation<SetCustomerDisabledVolumePoolsMutation, SetCustomerDisabledVolumePoolsMutationVariables>({
      query: (variables) => ({ document: SetCustomerDisabledVolumePoolsDocument, variables })
    }),
    SetCustomerStatementDelivery: build.mutation<SetCustomerStatementDeliveryMutation, SetCustomerStatementDeliveryMutationVariables>({
      query: (variables) => ({ document: SetCustomerStatementDeliveryDocument, variables })
    }),
    SetCustomerTaxDetails: build.mutation<SetCustomerTaxDetailsMutation, SetCustomerTaxDetailsMutationVariables>({
      query: (variables) => ({ document: SetCustomerTaxDetailsDocument, variables })
    }),
    SetCustomerMinimumFreightCharge: build.mutation<SetCustomerMinimumFreightChargeMutation, SetCustomerMinimumFreightChargeMutationVariables>({
      query: (variables) => ({ document: SetCustomerMinimumFreightChargeDocument, variables })
    }),
    ImportUpsertCustomer: build.mutation<ImportUpsertCustomerMutation, ImportUpsertCustomerMutationVariables>({
      query: (variables) => ({ document: ImportUpsertCustomerDocument, variables })
    }),
    UpsertLocations: build.mutation<UpsertLocationsMutation, UpsertLocationsMutationVariables>({
      query: (variables) => ({ document: UpsertLocationsDocument, variables })
    }),
    UpsertBillingAddresses: build.mutation<UpsertBillingAddressesMutation, UpsertBillingAddressesMutationVariables>({
      query: (variables) => ({ document: UpsertBillingAddressesDocument, variables })
    }),
    UpsertContacts: build.mutation<UpsertContactsMutation, UpsertContactsMutationVariables>({
      query: (variables) => ({ document: UpsertContactsDocument, variables })
    }),
    AddCustomerUpgrade: build.mutation<AddCustomerUpgradeMutation, AddCustomerUpgradeMutationVariables>({
      query: (variables) => ({ document: AddCustomerUpgradeDocument, variables })
    }),
    UpdateCustomerUpgrade: build.mutation<UpdateCustomerUpgradeMutation, UpdateCustomerUpgradeMutationVariables>({
      query: (variables) => ({ document: UpdateCustomerUpgradeDocument, variables })
    }),
    ToggleCustomerUpgradeDefault: build.mutation<ToggleCustomerUpgradeDefaultMutation, ToggleCustomerUpgradeDefaultMutationVariables>({
      query: (variables) => ({ document: ToggleCustomerUpgradeDefaultDocument, variables })
    }),
    DeactivateCustomerUpgrade: build.mutation<DeactivateCustomerUpgradeMutation, DeactivateCustomerUpgradeMutationVariables>({
      query: (variables) => ({ document: DeactivateCustomerUpgradeDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAddCustomerMutation, useEditCustomerMutation, useAddLocationMutation, useRemoveLocationMutation, useUpdateLocationMutation, useAddContactMutation, useUpdateContactMutation, useRemoveContactMutation, useAddBillingAddressMutation, useRemoveBillingAddressMutation, useUpdateBillingAddressMutation, useInactivateCustomerMutation, useActivateCustomerMutation, useDeleteCustomerMutation, useBatchInactivateCustomersMutation, useBatchActivateCustomersMutation, useBatchDeleteCustomersMutation, useMergeCustomerMutation, useUpdateCustomerOrderAddressEditPermissionsMutation, useUpdateCustomerLocationOrderAddressEditPermissionsMutation, useUpdateCustomerSendOrderEmailsMutation, useUpdateCustomerSendInvoiceEmailsMutation, useSetCustomerTypeMutation, useSetCustomerDepositRequirementMutation, useUpdateCustomerLocationSendOrderEmailsMutation, useUpdateCustomerLocationSendInvoiceEmailsMutation, useSetCustomerLocationServicingSiteMutation, useSetCustomerLocationCoordinatesMutation, useSetCustomerLocationReceivingEmailMutation, useSetCustomerLocationDeliveryScheduleMutation, useReplaceCustomerSalesPeopleMutation, useReplaceLocationSalesPeopleMutation, useSetLocationOrderEmailContactsMutation, useSetCustomerNoteMutation, useClearCustomerNoteMutation, useSetCustomerLocationNoteMutation, useClearCustomerLocationNoteMutation, useAddCustomerLocationSettingsNoteMutation, useEditCustomerLocationSettingsNoteMutation, useSetCustomerOrderEntryUnitMutation, useSetCustomerPriceEntryUnitMutation, useSetCustomerDisabledVolumePoolsMutation, useSetCustomerStatementDeliveryMutation, useSetCustomerTaxDetailsMutation, useSetCustomerMinimumFreightChargeMutation, useImportUpsertCustomerMutation, useUpsertLocationsMutation, useUpsertBillingAddressesMutation, useUpsertContactsMutation, useAddCustomerUpgradeMutation, useUpdateCustomerUpgradeMutation, useToggleCustomerUpgradeDefaultMutation, useDeactivateCustomerUpgradeMutation } = injectedRtkApi;
